
export const strongTranslationsHI = {
  "G11": {
    m: "अब्राहम",
    d: "पितृसत्ता अब्राहम, विश्वासियों के पिता।",
    u: "नए नियम में 73 बार उपयोग किया गया। विश्वास का आदर्श।",
    e: "इब्रानी אַבְרָהָם (अब्राहाम) से = भीड़ का पिता"
  },
  "G25": {
    m: "दिव्य और निःस्वार्थ प्रेम से प्रेम करना",
    d: "निःस्वार्थ, त्यागपूर्ण और दिव्य प्रेम से प्रेम करना। यह वह प्रेम है जो परमेश्वर का मानवता के लिए है, और वह प्रेम जिससे हमें एक-दूसरे से प्रेम करना चाहिए।",
    u: "नए नियम में 143 बार उपयोग किया गया। दिव्य, पूर्ण और निःशर्त प्रेम का वर्णन करता है।",
    e: "ἄγω (एगो) से = मार्गदर्शन करना, भलाई की ओर ले जाना"
  },
  "G26": {
    m: "दिव्य प्रेम, दया",
    d: "परमेश्वर का पूर्ण प्रेम; भाईचारे का प्रेम, स्नेह, सद्भावना, दया। वह प्रेम जो परमेश्वर और मनुष्य को, और मनुष्य को अपने पड़ोसी से जोड़ता है।",
    u: "नए नियम में 116 बार उपयोग किया गया। दिव्य प्रेम का वर्णन करने के लिए मसीहियत का केंद्रीय शब्द।",
    e: "ἀγαπάω (अगापाओ) से निकला"
  },
  "G27": {
    m: "प्रिय, प्यारा",
    d: "प्रिय, प्यारा; परमेश्वर या मनुष्यों का प्रिय।",
    u: "नए नियम में 61 बार उपयोग किया गया। परमेश्वर का प्रिय पुत्र।",
    e: "ἀγαπάω (अगापाओ) = प्रेम करना से"
  },
  "G32": {
    m: "दूत, स्वर्गदूत",
    d: "संदेशवाहक; परमेश्वर की सेवा में स्वर्गदूत।",
    u: "नए नियम में 175 बार उपयोग किया गया। परमेश्वर के दूत।",
    e: "ἀγγέλλω (अन्जेल्लो) से = घोषित करना"
  },
  "G36": {
    m: "निम्न जन्म का, तुच्छ",
    d: "कुलीनता रहित, निम्न वंश का; तिरस्कृत।",
    u: "नए नियम में 1 बार उपयोग किया गया (1 कुरिन्थियों 1:28)।",
    e: "ἀ- (नकारात्मक) + γένος (जेनोस) = जन्म से"
  },
  "G93": {
    m: "अन्याय, अधर्म",
    d: "कानून का उल्लंघन, अन्याय; दुष्टता, नैतिक अधर्म।",
    u: "नए नियम में 25 बार उपयोग किया गया। δικαιοσύνη (धार्मिकता) का विपरीत।",
    e: "ἀ- (नकारात्मक) + δίκη (डाइक) = न्याय से"
  },
  "G154": {
    m: "माँगना, प्रार्थना करना, विनती करना",
    d: "माँगना, किसी चीज़ के लिए प्रार्थना करना, विनती करना, याचना करना। विनम्र और सम्मानजनक अनुरोध।",
    u: "नए नियम में 70 बार उपयोग किया गया। परमेश्वर या मनुष्यों से किया गया अनुरोध।",
    e: "αἰτέω (आइतेओ) मूल जड़ से; माँगना"
  },
  "G166": {
    m: "शाश्वत, नित्य",
    d: "बिना शुरुआत और अंत के, हमेशा मौजूद; नए नियम में, अक्सर परमेश्वर में शाश्वत जीवन से जुड़ा।",
    u: "नए नियम में 71 बार उपयोग किया गया। अक्सर शाश्वत जीवन और परमेश्वर के राज्य का वर्णन करता है।",
    e: "αἰών (आयोन) से = युग, काल, अनंतता"
  },
  "G225": {
    m: "सत्य, वास्तविकता",
    d: "जो परमेश्वर और मनुष्य के कर्तव्यों से संबंधित बातों में सत्य है; प्रकट दिव्य सत्य।",
    u: "नए नियम में 109 बार उपयोग किया गया। यीशु की शिक्षा की केंद्रीय अवधारणा।",
    e: "ἀληθής (अलेथेस) से = सच्चा, ईमानदार"
  },
  "G281": {
    m: "आमीन, सचमुच",
    d: "पुष्टि का सूत्र: ऐसा ही हो, सचमुच, निश्चित रूप से।",
    u: "नए नियम में 129 बार उपयोग किया गया। यीशु कहते हैं 'सचमुच, सचमुच'।",
    e: "इब्रानी אָמֵן (आमेन) से = दृढ़, विश्वासयोग्य"
  },
  "G444": {
    m: "मनुष्य, मानव",
    d: "मानव, पुरुष या महिला; सामान्य रूप से मानवता।",
    u: "नए नियम में 550 बार उपयोग किया गया। परमेश्वर की छवि में बना मनुष्य।",
    e: "ἀνήρ (अनेर) = पुरुष और ὤψ (ओप्स) = चेहरा से"
  },
  "G622": {
    m: "खोना, नष्ट करना, नाश होना",
    d: "पूरी तरह नष्ट करना; खोना, नाश होना; बर्बाद होना।",
    u: "नए नियम में 90 बार उपयोग किया गया। जो खोया था उसे बचाना।",
    e: "ἀπό (अपो) = से + ὄλλυμι (ओल्लुमी) = नष्ट करना से"
  },
  "G649": {
    m: "भेजना, प्रतिनिधि बनाना",
    d: "मिशन के साथ भेजना; राजदूत के रूप में प्रतिनिधि बनाना।",
    u: "नए नियम में 132 बार उपयोग किया गया। पिता पुत्र को भेजता है।",
    e: "ἀπό (अपो) = से + στέλλω (स्टेल्लो) = भेजना से"
  },
  "G721": {
    m: "मेमना",
    d: "छोटा मेमना; यीशु मसीह को परमेश्वर के मेमने के रूप में दर्शाता है।",
    u: "नए नियम में 30 बार उपयोग किया गया, विशेष रूप से प्रकाशितवाक्य में।",
    e: "ἀρήν (एरेन) = मेमना का लघु रूप"
  },
  "G730": {
    m: "पुरुष, नर",
    d: "पुरुष लिंग का, नर।",
    u: "नए नियम में 9 बार उपयोग किया गया। परमेश्वर ने मनुष्य को नर और नारी बनाया।",
    e: "प्राथमिक मूल"
  },
  "G740": {
    m: "रोटी",
    d: "रोटी, भोजन; जीवन की रोटी = मसीह।",
    u: "नए नियम में 97 बार उपयोग किया गया। यीशु जीवन की रोटी।",
    e: "ἄρω (आरो) से = उठाना, ऊपर उठाना"
  },
  "G746": {
    m: "आरंभ, मूल",
    d: "आरंभ, उत्पत्ति, प्रथम सिद्धांत। यूहन्ना 1:1-2 में, यह उस शाश्वत आरंभ को दर्शाता है जहाँ वचन (लोगोस) पहले से ही विद्यमान था।",
    u: "नए नियम में 55 बार उपयोग किया गया। यूहन्ना 1:1 का मुख्य शब्द 'आदि में वचन था'।",
    e: "प्राथमिक शब्द; आरंभ, प्रथम मूल"
  },
  "G772": {
    m: "कमजोर, बीमार",
    d: "बल रहित, कमजोर; बीमार, अशक्त; आध्यात्मिक रूप से कमजोर।",
    u: "नए नियम में 25 बार उपयोग किया गया। परमेश्वर संसार के कमजोरों को चुनता है।",
    e: "ἀ- (नकारात्मक) + σθένος (स्थेनोस) = शक्ति से"
  },
  "G907": {
    m: "बपतिस्मा देना, डुबाना",
    d: "पानी में डुबाना; शुद्धिकरण या दीक्षा के लिए बपतिस्मा देना।",
    u: "नए नियम में 77 बार उपयोग किया गया। मसीही बपतिस्मा।",
    e: "βάπτω (बाप्तो) से = डुबाना, डुबकी लगाना"
  },
  "G1080": {
    m: "जन्म देना, उत्पन्न करना",
    d: "जन्म देना, पैदा करना; आध्यात्मिक रूप से नया जन्म लेना।",
    u: "नए नियम में 97 बार उपयोग किया गया। परमेश्वर से जन्मा, नया जन्म।",
    e: "प्राथमिक मूल"
  },
  "G1096": {
    m: "बनना, होना, घटित होना",
    d: "बनना, अस्तित्व में आना, होना, घटित होना, जन्म लेना।",
    u: "नए नियम में 678 बार उपयोग किया गया। 'सब कुछ उसी के द्वारा उत्पन्न हुआ' (यूहन्ना 1:3)।",
    e: "γίνομαι (गिनोमाई) = बनना से"
  },
  "G1097": {
    m: "जानना, समझना",
    d: "व्यक्तिगत अनुभव से जानना; समझना, अनुभव करना, जागरूक होना।",
    u: "नए नियम में 222 बार उपयोग किया गया। अनुभवात्मक ज्ञान, केवल बौद्धिक नहीं।",
    e: "इंडो-यूरोपीय मूल *gen- = जन्म देना, जानना"
  },
  "G1100": {
    m: "जीभ, भाषा",
    d: "वाणी का अंग; भाषा, बोली; भाषाओं का वरदान।",
    u: "नए नियम में 50 बार उपयोग किया गया। भाषाओं का वरदान।",
    e: "प्राथमिक मूल"
  },
  "G1166": {
    m: "दिखाना, प्रदर्शित करना",
    d: "आँखों के सामने रखना, दिखाना; साबित करना, प्रदर्शित करना।",
    u: "नए नियम में 33 बार उपयोग किया गया। परमेश्वर अपनी महिमा दिखाता है।",
    e: "प्राथमिक मूल"
  },
  "G1208": {
    m: "दूसरा",
    d: "श्रृंखला या क्रम में दूसरा।",
    u: "नए नियम में 44 बार उपयोग किया गया। दूसरी आज्ञा।",
    e: "δύο (डुओ) = दो से"
  },
  "G1271": {
    m: "बुद्धि, विचार",
    d: "सोचने, सुनने, समझने की क्षमता; मन, समझ।",
    u: "नए नियम में 12 बार उपयोग किया गया। मसीह द्वारा नवीनीकृत मन।",
    e: "διά (डाया) = के माध्यम से + νοῦς (नूस) = मन से"
  },
  "G1320": {
    m: "शिक्षक, गुरु, उपदेशक",
    d: "शिक्षक, उपदेशक; जो धार्मिक सत्य सिखाता है।",
    u: "नए नियम में 59 बार उपयोग किया गया। 'रब्बी, हम जानते हैं कि तू परमेश्वर की ओर से आया हुआ गुरु है' (यूहन्ना 3:2)।",
    e: "διδάσκω (दिदास्को) = सिखाना से"
  },
  "G1325": {
    m: "देना, प्रदान करना",
    d: "किसी को कुछ देना; प्रदान करना, अनुमति देना; सौंपना।",
    u: "नए नियम में 415 बार उपयोग किया गया। परमेश्वर उदारता से देता है।",
    e: "प्राथमिक मूल"
  },
  "G1372": {
    m: "प्यासा होना, तीव्र इच्छा करना",
    d: "प्यास से पीड़ित होना; तीव्र इच्छा करना, लालायित होना।",
    u: "नए नियम में 16 बार उपयोग किया गया। परमेश्वर की आध्यात्मिक प्यास।",
    e: "δίψα (डिप्सा) = प्यास से"
  },
  "G1401": {
    m: "दास, सेवक",
    d: "दास, सेवक; स्वैच्छिक परमेश्वर का सेवक।",
    u: "नए नियम में 124 बार उपयोग किया गया। मसीह के सेवक।",
    e: "δέω (देओ) से = बांधना"
  },
  "G1411": {
    m: "शक्ति, सामर्थ्य, चमत्कार",
    d: "बल, शक्ति, क्षमता; शक्ति का कार्य, चमत्कार।",
    u: "नए नियम में 120 बार उपयोग किया गया। परमेश्वर की शक्ति, पवित्र आत्मा की।",
    e: "δύναμαι (डुनामाई) = सक्षम होना से"
  },
  "G1417": {
    m: "दो",
    d: "संख्या दो; एक जोड़ा।",
    u: "नए नियम में 135 बार उपयोग किया गया। दो या तीन गवाह।",
    e: "प्राथमिक मूल"
  },
  "G1473": {
    m: "मैं",
    d: "प्रथम पुरुष एकवचन का व्यक्तिगत सर्वनाम।",
    u: "नए नियम में 2567 बार उपयोग किया गया। बहुत लगातार।",
    e: "प्राथमिक सर्वनाम"
  },
  "G1484": {
    m: "राष्ट्र, लोग, अन्यजाति",
    d: "लोग, राष्ट्र; अन्यजाति राष्ट्र (गैर-यहूदी)।",
    u: "नए नियम में 162 बार उपयोग किया गया। सभी राष्ट्रों के लिए सुसमाचार।",
    e: "प्राथमिक मूल"
  },
  "G1492": {
    m: "जानना, देखना, समझना",
    d: "धारणा द्वारा जानना, देखना, समझना, जानना। अनुभव या प्रकाशन के माध्यम से प्राप्त ज्ञान।",
    u: "नए नियम में 666 बार उपयोग किया गया। यूहन्ना के सुसमाचार में ज्ञान की मूलभूत क्रिया।",
    e: "εἴδω (आइडो) का पूर्ण रूप; देखना, जानना"
  },
  "G1510": {
    m: "होना, अस्तित्व में होना",
    d: "सभी अर्थों में होने की क्रिया; अस्तित्व में होना, रहना, घटित होना।",
    u: "नए नियम में सबसे अधिक उपयोग की गई क्रिया (2460+ बार)।",
    e: "प्राथमिक मूल"
  },
  "G1515": {
    m: "शांति",
    d: "शांति की स्थिति; परमेश्वर के साथ शांति; लोगों के बीच सामंजस्य।",
    u: "नए नियम में 92 बार उपयोग किया गया। मसीह की शांति।",
    e: "εἴρω (इरो) से = जोड़ना, बांधना"
  },
  "G1520": {
    m: "एक, अद्वितीय",
    d: "केवल एक; अद्वितीय, मात्र; एक निश्चित।",
    u: "नए नियम में 344 बार उपयोग किया गया। परमेश्वर की एकता, संयुक्त कलीसिया।",
    e: "प्राथमिक मूल"
  },
  "G1586": {
    m: "चुनना, चयन करना",
    d: "अपने लिए चुनना, चयन करना; दिव्य अनुग्रह से चुनना।",
    u: "नए नियम में 21 बार उपयोग किया गया। परमेश्वर अपने बच्चों को चुनता है।",
    e: "ἐκ (एक) = से बाहर + λέγω (लेगो) = चुनना से"
  },
  "G1658": {
    m: "स्वतंत्र, मुक्त",
    d: "स्वतंत्र, दास नहीं; पाप की दासता से मुक्त।",
    u: "नए नियम में 23 बार उपयोग किया गया। मसीह में मुक्त।",
    e: "संभवतः ἔρχομαι (एर्खोमाई) = आना से"
  },
  "G1672": {
    m: "यूनानी, अन्यजाति",
    d: "जन्म या भाषा से यूनानी; गैर-यहूदी।",
    u: "नए नियम में 25 बार उपयोग किया गया। मसीह में न यहूदी न यूनानी।",
    e: "Ἑλλάς (हेल्लास) = यूनान से"
  },
  "G1680": {
    m: "आशा, विश्वासपूर्ण प्रत्याशा",
    d: "अच्छी चीजों की प्रतीक्षा, परमेश्वर पर आधारित आशा; दिव्य प्रतिज्ञाओं पर आधारित भविष्य में विश्वास।",
    u: "नए नियम में 54 बार उपयोग किया गया। विश्वास और प्रेम के साथ तीन धार्मिक गुणों में से एक।",
    e: "ἔλπω (एल्पो) से = प्रतीक्षा करना, आशा करना"
  },
  "G1743": {
    m: "मजबूत करना, शक्तिशाली बनाना",
    d: "मजबूत बनाना, सशक्त करना; शक्ति देना।",
    u: "नए नियम में 8 बार उपयोग किया गया। परमेश्वर विश्वासियों को सशक्त करता है।",
    e: "ἐν (एन) = में + δυναμόω (डुनामो ओ) = शक्तिशाली बनाना से"
  },
  "G1746": {
    m: "पहनना, धारण करना",
    d: "वस्त्र पहनना; गुण या शक्ति धारण करना।",
    u: "नए नियम में 27 बार उपयोग किया गया। मसीह को पहनना, परमेश्वर के कवच को पहनना।",
    e: "ἐν (एन) = में + δύω (डुओ) = प्रवेश करना, पहनना से"
  },
  "G1785": {
    m: "आज्ञा, आदेश",
    d: "आदेश, आज्ञा, नियम; विशेष रूप से दिव्य आज्ञा।",
    u: "नए नियम में 67 बार उपयोग किया गया। परमेश्वर और मसीह की आज्ञाएँ।",
    e: "ἐντέλλομαι (एन्तेल्लोमाई) = आज्ञा देना से"
  },
  "G1848": {
    m: "तिरस्कार करना, घृणा से व्यवहार करना",
    d: "कुछ नहीं समझना, तिरस्कार करना; अवमानना से व्यवहार करना।",
    u: "नए नियम में 11 बार उपयोग किया गया। संसार उसे तिरस्कृत करता है जिसे परमेश्वर चुनता है।",
    e: "ἐξ (एक्स) = से बाहर + οὐθείς (ओउथीस) = कोई नहीं से"
  },
  "G2041": {
    m: "कार्य, काम, कृत्य",
    d: "काम, श्रम; क्रिया, कृत्य; किया गया कार्य।",
    u: "नए नियम में 169 बार उपयोग किया गया। परमेश्वर के कार्य, अच्छे कार्य।",
    e: "ἔργω (एर्गो) = काम करना से"
  },
  "G2048": {
    m: "मरुभूमि, निर्जन",
    d: "निर्जन स्थान, जंगल; निर्जन, वीरान।",
    u: "नए नियम में 48 बार उपयोग किया गया। मरुभूमि में यीशु के 40 दिन।",
    e: "ἔρημος (एरेमोस) से = परित्यक्त"
  },
  "G2065": {
    m: "पूछना, पूछताछ करना",
    d: "पूछना, पूछताछ करना, जानकारी के लिए पूछना। जाँच या अन्वेषण।",
    u: "नए नियम में 63 बार उपयोग किया गया। उत्तर पाने के लिए पूछना।",
    e: "अनिश्चित जड़; पूछना, पूछताछ करना"
  },
  "G2189": {
    m: "शत्रुता, वैर",
    d: "घृणा, शत्रुता, वैर।",
    u: "नए नियम में 6 बार उपयोग किया गया। परमेश्वर के साथ शत्रुता समाप्त।",
    e: "ἐχθρός (एख्थ्रोस) = शत्रु से"
  },
  "G2205": {
    m: "उत्साह, ईर्ष्या",
    d: "भावुक उत्साह; सकारात्मक (परमेश्वर के लिए उत्साह) या नकारात्मक (ईर्ष्या) हो सकता है।",
    u: "नए नियम में 16 बार उपयोग किया गया। संदर्भ के अनुसार गुण या दोष हो सकता है।",
    e: "ζέω (ज़ेओ) से = उबलना, उत्साही होना"
  },
  "G2222": {
    m: "जीवन",
    d: "शारीरिक या आध्यात्मिक जीवन; परमेश्वर में शाश्वत जीवन।",
    u: "नए नियम में 135 बार उपयोग किया गया। यीशु जीवन है।",
    e: "ζάω (ज़ाओ) से = जीना"
  },
  "G2258": {
    m: "था, वह था",
    d: "था, वह था, वह थी। होने की क्रिया (εἰμί) का अपूर्ण रूप। अतीत में एक स्थिति या अस्तित्व को व्यक्त करता है।",
    u: "नए नियम में 267 बार उपयोग किया गया। यूहन्ना 1:1 में महत्वपूर्ण 'आदि में वचन था'।",
    e: "εἰμί (इमी) का अपूर्ण काल = होना; था"
  },
  "G2296": {
    m: "आश्चर्य करना, चकित होना, प्रशंसा करना",
    d: "आश्चर्य करना, चकित होना, हैरान होना, प्रशंसा करना। किसी असाधारण चीज़ के प्रति विस्मय की प्रतिक्रिया।",
    u: "नए नियम में 43 बार उपयोग किया गया। यीशु के चमत्कारों और शिक्षाओं के प्रति लगातार प्रतिक्रिया।",
    e: "θαῦμα (थौमा) = चमत्कार से; आश्चर्य करना"
  },
  "G2316": {
    m: "परमेश्वर, देवता",
    d: "एकमात्र सच्चा परमेश्वर, सर्वोच्च और शाश्वत सत्ता। नए नियम में परमपिता परमेश्वर, या यीशु मसीह पुत्र, या पवित्र आत्मा को दर्शाता है - पवित्र त्रिमूर्ति।",
    u: "नए नियम में 1343 बार उपयोग किया गया। त्रिमूर्ति की एकता में एकमात्र सच्चे परमेश्वर को दर्शाने वाला मूल शब्द।",
    e: "स्ट्रांग के अनुसार अनिश्चित संबंध। एक देवता को दर्शाता है, विशेषकर सर्वोच्च दिव्यता को। बाइबिल का उपयोग: उस जीवित परमेश्वर को प्रकट करता है जो मुक्ति के इतिहास में कार्य करता है।"
  },
  "G2338": {
    m: "स्त्री, मादा",
    d: "स्त्री लिंग का, मादा।",
    u: "नए नियम में 5 बार उपयोग किया गया। मसीह में नर और नारी बराबर।",
    e: "θηλάζω (थेलाज़ो) से = दूध पिलाना"
  },
  "G2362": {
    m: "सिंहासन",
    d: "राजसी सीट, सिंहासन; शाही शक्ति और अधिकार।",
    u: "नए नियम में 62 बार उपयोग किया गया। परमेश्वर और मेमने का सिंहासन।",
    e: "प्राथमिक मूल"
  },
  "G2381": {
    m: "थोमा",
    d: "थोमा, व्यक्तिवाचक नाम। बारह प्रेरितों में से एक, जिसे दीदुमुस (जुड़वाँ) भी कहा जाता है। पुनरुत्थान के प्रमाण माँगने के लिए प्रसिद्ध।",
    u: "नए नियम में 11 बार उपयोग किया गया। वह प्रेरित जिसने संदेह किया और फिर विश्वास किया।",
    e: "अरामी תְּאוֹמָא (तेओमा) से = जुड़वाँ"
  },
  "G2398": {
    m: "अपना, विशेष, व्यक्तिगत",
    d: "अपना, विशेष, व्यक्तिगत, निजी। जो किसी का अपना हो, दूसरों से अलग।",
    u: "नए नियम में 114 बार उपयोग किया गया। व्यक्तिगत स्वामित्व और भेद की अवधारणा।",
    e: "अनिश्चित मूल से; अपना, विशेष"
  },
  "G2424": {
    m: "यीशु",
    d: "नासरत का यीशु, मसीहा, उद्धारकर्ता।",
    u: "नए नियम में 917 बार उपयोग किया गया। सब नामों से ऊपर नाम।",
    e: "इब्रानी יְהוֹשֻׁעַ (यहोशू) से = यहोवा बचाता है"
  },
  "G2453": {
    m: "यहूदी",
    d: "यहूदी जाति से संबंधित; यहूदिया का निवासी।",
    u: "नए नियम में 195 बार उपयोग किया गया। यहूदी, परमेश्वर के चुने हुए लोग।",
    e: "Ἰούδας (यूदास) = यहूदा से"
  },
  "G2491": {
    m: "यूहन्ना",
    d: "यूहन्ना, व्यक्तिवाचक नाम। यूहन्ना बपतिस्मा देने वाला अग्रदूत, यूहन्ना प्रिय प्रेरित, सुसमाचार और पत्रों के लेखक।",
    u: "नए नियम में 135 बार उपयोग किया गया। नए नियम के दो महान व्यक्तित्वों का नाम।",
    e: "इब्रानी יוֹחָנָן (योहानान) से = यहोवा कृपालु है"
  },
  "G2531": {
    m: "जैसे, जिस प्रकार",
    d: "जैसे, उसी तरह से; जिस प्रकार, जितना।",
    u: "नए नियम में 182 बार उपयोग किया गया। तुलनात्मक संयोजक।",
    e: "κατά (काटा) = अनुसार + ὡς (होस) = जैसे से"
  },
  "G2537": {
    m: "नया, ताजा",
    d: "समय या गुण में नया; ताजा, हाल का, अप्रयुक्त।",
    u: "नए नियम में 42 बार उपयोग किया गया। नई सृष्टि, नई आज्ञा।",
    e: "अनिश्चित मूल"
  },
  "G2570": {
    m: "अच्छा, सुंदर",
    d: "प्रकृति में अच्छा, सुंदर; सम्मानजनक, उत्कृष्ट, सदाचारी।",
    u: "नए नियम में 100 बार उपयोग किया गया। अच्छा चरवाहा, अच्छे कार्य।",
    e: "प्राथमिक मूल"
  },
  "G2588": {
    m: "हृदय",
    d: "शारीरिक हृदय; आंतरिक जीवन का केंद्र, आत्मा, मन; विचार और भावनाएँ।",
    u: "नए नियम में 156 बार उपयोग किया गया। आध्यात्मिक जीवन का केंद्र।",
    e: "प्राथमिक मूल"
  },
  "G2596": {
    m: "अनुसार, विरुद्ध, के माध्यम से",
    d: "कई अर्थों वाला पूर्वसर्ग: अनुसार, के अनुरूप; विरुद्ध; के माध्यम से।",
    u: "नए नियम में 470 से अधिक बार उपयोग किया गया। बहुत लगातार पूर्वसर्ग।",
    e: "प्राथमिक पूर्वसर्ग"
  },
  "G2617": {
    m: "शर्मिंदा करना, अपमानित करना",
    d: "शर्मिंदा करना, अपमानित करना; भ्रमित करना, नीचा दिखाना।",
    u: "नए नियम में 13 बार उपयोग किया गया। परमेश्वर संसार के बुद्धिमानों को भ्रमित करता है।",
    e: "κατά (काटा) = विरुद्ध + αἰσχύνω (आइसखुनो) = शर्म से"
  },
  "G2744": {
    m: "घमंड करना, डींग मारना",
    d: "घमंड करना, डींग मारना; किसी चीज़ में अपना गौरव पाना।",
    u: "नए नियम में 37 बार उपयोग किया गया। प्रभु में घमंड करना।",
    e: "καῦχος (काऊखोस) = डींग से"
  },
  "G2889": {
    m: "संसार, ब्रह्मांड, मानवता",
    d: "विश्व व्यवस्था, ब्रह्मांड; पतित मानवता; परमेश्वर के विरोधी व्यवस्था।",
    u: "नए नियम में 186 बार उपयोग किया गया। सृष्टि या पापी व्यवस्था को दर्शा सकता है।",
    e: "κοσμέω (कोस्मेओ) से = सजाना, व्यवस्थित करना"
  },
  "G2919": {
    m: "न्याय करना, निर्णय लेना",
    d: "न्याय करना, निर्णय सुनाना; निर्णय लेना, निर्धारित करना।",
    u: "नए नियम में 114 बार उपयोग किया गया। परमेश्वर संसार का न्याय करता है।",
    e: "प्राथमिक मूल"
  },
  "G2920": {
    m: "न्याय, न्यायशीलता, दण्ड",
    d: "न्याय, न्यायशीलता, दण्ड, न्यायिक निर्णय। परमेश्वर का न्याय, न्यायसंगत और सिद्ध।",
    u: "नए नियम में 47 बार उपयोग किया गया। दिव्य न्याय की केंद्रीय अवधारणा।",
    e: "κρίνω (क्रिनो) से = न्याय करना, निर्णय करना"
  },
  "G2962": {
    m: "प्रभु, स्वामी, मालिक",
    d: "प्रभु, स्वामी; सम्मान और दिव्य अधिकार का शीर्षक; यीशु प्रभु के रूप में।",
    u: "नए नियम में 748 बार उपयोग किया गया। 'थोमा ने उससे कहा: प्रभु, हम नहीं जानते कि तू कहाँ जाता है' (यूहन्ना 14:5)।",
    e: "κύριος (कुरिओस) = अधिकार रखना से"
  },
  "G2992": {
    m: "लोग",
    d: "लोग, राष्ट्र; विशेष रूप से परमेश्वर के लोग (इस्राएल या कलीसिया)।",
    u: "नए नियम में 142 बार उपयोग किया गया। परमेश्वर के चुने हुए लोग।",
    e: "प्राथमिक मूल"
  },
  "G3022": {
    m: "सफेद, चमकीला",
    d: "सफेद, तेजस्वी; शुद्धता और विजय का प्रतीक।",
    u: "नए नियम में 25 बार उपयोग किया गया। छुड़ाए हुओं के सफेद वस्त्र।",
    e: "λευκός (लेऊकोस) से = सफेद, चमकदार"
  },
  "G3056": {
    m: "वचन, शब्द, तर्क",
    d: "बोला गया शब्द; तर्क, बुद्धि; लोगोस = मसीह।",
    u: "नए नियम में 330 बार उपयोग किया गया। अवतरित लोगोस।",
    e: "λέγω (लेगो) = कहना से"
  },
  "G3101": {
    m: "शिष्य, विद्यार्थी",
    d: "सीखने वाला, छात्र, शिष्य; यीशु का अनुयायी।",
    u: "नए नियम में 261 बार उपयोग किया गया। मसीह के अनुयायियों को दर्शाता है।",
    e: "μανθάνω (मन्थानो) = सीखना से"
  },
  "G3141": {
    m: "गवाही, साक्ष्य",
    d: "गवाही, साक्ष्य, प्रमाण। सत्य की गवाही, विशेषकर मसीह की।",
    u: "नए नियम में 37 बार उपयोग किया गया। यूहन्ना के सुसमाचार का प्रमुख विषय।",
    e: "μάρτυς (मार्तुस) से = गवाह"
  },
  "G3173": {
    m: "महान, महत्वपूर्ण",
    d: "आकार, मात्रा या महत्व में बड़ा; शक्तिशाली, अद्भुत।",
    u: "नए नियम में 243 बार उपयोग किया गया। परमेश्वर की महानता।",
    e: "प्राथमिक मूल"
  },
  "G3320": {
    m: "विभाजन की दीवार",
    d: "बीच की दीवार, विभाजन की रुकावट।",
    u: "नए नियम में 1 बार उपयोग किया गया (इफिसियों 2:14)। यहूदियों और अन्यजातियों के बीच की दीवार।",
    e: "μέσος (मेसोस) = बीच + τοῖχος (तोइखोस) = दीवार से"
  },
  "G3439": {
    m: "एकलौता, इकलौता जन्मा",
    d: "अपनी तरह का अनूठा, एकलौता जन्मा; इकलौता पुत्र।",
    u: "नए नियम में 9 बार उपयोग किया गया। परमेश्वर का इकलौता पुत्र।",
    e: "μόνος (मोनोस) = अकेला + γίνομαι (गिनोमाई) = बनना से"
  },
  "G3474": {
    m: "मूर्खता, अज्ञानता",
    d: "मूर्खता, बेतुकापन; जो बुद्धि से रहित है।",
    u: "नए नियम में 5 बार उपयोग किया गया। परमेश्वर की बुद्धि संसार को मूर्खता लगती है।",
    e: "μωρός (मोरोस) से = मूर्ख, अज्ञानी"
  },
  "G3475": {
    m: "मूसा",
    d: "मूसा, इस्राएल का विधि निर्माता।",
    u: "नए नियम में 80 बार उपयोग किया गया। मूसा की व्यवस्था।",
    e: "इब्रानी מֹשֶׁה (मोशे) से = निकाला गया (पानी से)"
  },
  "G3530": {
    m: "नीकुदेमुस",
    d: "नीकुदेमुस, व्यक्तिवाचक नाम। फरीसी और यहूदी नेता जो रात में यीशु के पास आया था। यूनानी नाम जिसका अर्थ है 'लोगों की जीत'।",
    u: "नए नियम में 5 बार उपयोग किया गया। यूहन्ना के सुसमाचार में महत्वपूर्ण व्यक्तित्व।",
    e: "यूनानी νίκη (निकी) = जीत और δῆμος (देमोस) = लोग से"
  },
  "G3551": {
    m: "व्यवस्था, तोरा",
    d: "व्यवस्था, तोरा, नियम, सिद्धांत। मूसा की व्यवस्था, दिव्य व्यवस्था, परमेश्वर की आज्ञाएँ।",
    u: "नए नियम में 194 बार उपयोग किया गया। दिव्य प्रकाशन की केंद्रीय अवधारणा।",
    e: "νέμω (नेमो) से = वितरित करना, देना; दी गई व्यवस्था"
  },
  "G3571": {
    m: "रात",
    d: "रात, सूर्यास्त और सूर्योदय के बीच अंधकार की अवधि। अक्सर आध्यात्मिक अज्ञानता के लिए रूपक।",
    u: "नए नियम में 61 बार उपयोग किया गया। यूहन्ना के प्रतीकवाद में प्रकाश के विपरीत।",
    e: "प्राथमिक स्त्रीलिंग संज्ञा; रात"
  },
  "G3598": {
    m: "मार्ग, रास्ता",
    d: "सड़क, मार्ग; जीवन शैली, आचरण; मुक्ति का मार्ग।",
    u: "नए नियम में 101 बार उपयोग किया गया। यीशु मार्ग है।",
    e: "प्राथमिक मूल"
  },
  "G3609": {
    m: "घरेलू, घर का",
    d: "घर से संबंधित, परिवार का सदस्य; घरेलू सेवक।",
    u: "नए नियम में 3 बार उपयोग किया गया। परमेश्वर के परिवार के सदस्यों का वर्णन करता है।",
    e: "οἶκος (ओइकोस) = घर से"
  },
  "G3664": {
    m: "समान, एक जैसा",
    d: "समान, उसी प्रकृति या चरित्र का; बराबर।",
    u: "नए नियम में 45 बार उपयोग किया गया। पहली के समान दूसरी आज्ञा।",
    e: "ὁμός (होमोस) = समान से"
  },
  "G3686": {
    m: "नाम",
    d: "नाम, उपाधि; प्रतिष्ठा; अधिकार, शक्ति।",
    u: "नए नियम में 228 बार उपयोग किया गया। यीशु का नाम।",
    e: "प्राथमिक मूल"
  },
  "G3708": {
    m: "देखना",
    d: "आँखों से देखना; अनुभव करना, समझना; प्रकट होना।",
    u: "नए नियम में 454 बार उपयोग किया गया। मसीह को देखना, पिता को देखना।",
    e: "प्राथमिक मूल"
  },
  "G3735": {
    m: "पहाड़, पर्वत",
    d: "पहाड़, पर्वत; ऊँची पहाड़ी।",
    u: "नए नियम में 63 बार उपयोग किया गया। रूपांतरण का पहाड़।",
    e: "संभवतः ὁράω (होराओ) = देखना से"
  },
  "G3756": {
    m: "नहीं",
    d: "पूर्ण निषेध, नहीं।",
    u: "नए नियम में 1600 से अधिक बार उपयोग किया गया। बहुत लगातार निषेधात्मक कण।",
    e: "प्राथमिक निषेधात्मक कण"
  },
  "G3762": {
    m: "कोई नहीं, कुछ नहीं, कोई भी नहीं",
    d: "कोई नहीं, कुछ नहीं, कोई भी नहीं, एक भी नहीं। अस्तित्व या मात्रा का पूर्ण निषेध।",
    u: "नए नियम में 234 बार उपयोग किया गया। बहुत सामान्य मजबूत निषेध।",
    e: "οὐδέ (ऊदे) और εἷς (हेइस) से; एक भी नहीं"
  },
  "G3778": {
    m: "यह, ये, इसे",
    d: "संकेतवाची सर्वनाम: यह, ये, इसे। निकट या पूर्व में उल्लिखित किसी चीज़ को दर्शाता है।",
    u: "नए नियम में 1388 बार उपयोग किया गया। सबसे लगातार संकेतवाची सर्वनाम।",
    e: "प्राथमिक संकेतवाची सर्वनाम"
  },
  "G3789": {
    m: "सांप",
    d: "सांप, सरीसृप; प्राचीन सांप (शैतान)।",
    u: "नए नियम में 14 बार उपयोग किया गया। जंगल में पीतल का सांप।",
    e: "प्राथमिक मूल"
  },
  "G3793": {
    m: "भीड़, समूह",
    d: "लोगों की भीड़, समूह; लोकप्रिय जनता।",
    u: "नए नियम में 175 बार उपयोग किया गया। यीशु के पीछे जाने वाली भीड़।",
    e: "ὄχος (ओखोस) = वाहन (जो ले जाता है) से"
  },
  "G3880": {
    m: "प्राप्त करना, लेना, स्वीकार करना",
    d: "प्राप्त करना, लेना, स्वीकार करना, पकड़ना। कुछ ऐसा प्राप्त करना जो प्रस्तुत या दिया गया हो।",
    u: "नए नियम में 59 बार उपयोग किया गया। सुसमाचार की स्वीकृति की केंद्रीय अवधारणा।",
    e: "παρά (पारा) = के पास और λαμβάνω (लैम्बानो) = लेना से"
  },
  "G3956": {
    m: "सब, हर",
    d: "सब, हर एक, सभी; संपूर्ण, कुल।",
    u: "नए नियम में 1244 बार उपयोग किया गया। सबसे लगातार शब्दों में से।",
    e: "प्राथमिक मूल"
  },
  "G3962": {
    m: "पिता",
    d: "प्राकृतिक या आध्यात्मिक पिता; पूर्वज; परमपिता परमेश्वर।",
    u: "नए नियम में 413 बार उपयोग किया गया। अक्सर परमेश्वर को दर्शाने के लिए।",
    e: "प्राथमिक मूल, लैटिन 'pater' से संबंधित"
  },
  "G4100": {
    m: "विश्वास करना, आस्था रखना",
    d: "पर विश्वास करना, आस्था रखना; भरोसा करना, निर्भर रहना।",
    u: "नए नियम में 241 बार उपयोग किया गया। उद्धार के लिए यीशु में विश्वास करना।",
    e: "πίστις (पिस्टिस) = विश्वास से"
  },
  "G4102": {
    m: "विश्वास, भरोसा, वफादारी",
    d: "किसी भी बात की सच्चाई में विश्वास, आस्था; नए नियम में परमेश्वर और दिव्य बातों के साथ मनुष्य के संबंध से संबंधित विश्वास।",
    u: "नए नियम में 244 बार उपयोग किया गया। मसीही विश्वास की केंद्रीय अवधारणा।",
    e: "πείθω (पेइथो) से = मनाना, आश्वस्त करना"
  },
  "G4138": {
    m: "पूर्णता, प्रचुरता, जो भरता है",
    d: "पूर्णता, प्रचुरता, जो पूरी तरह भरता है। संपूर्णता, दिव्य पूर्णता।",
    u: "नए नियम में 17 बार उपयोग किया गया। मसीह में दिव्य पूर्णता की धर्मशास्त्रीय अवधारणा।",
    e: "πλήρης (प्लेरेस) = भरा हुआ से; पूर्णता"
  },
  "G4139": {
    m: "पड़ोसी",
    d: "जो निकट है, पड़ोसी; सामान्य रूप से निकटवर्ती।",
    u: "नए नियम में 17 बार उपयोग किया गया। 'अपने पड़ोसी से अपने समान प्रेम करो'।",
    e: "क्रिया विशेषण जो संज्ञा बन गया, πλησίος (प्लेसिओस) = निकट से"
  },
  "G4151": {
    m: "आत्मा, श्वास, वायु",
    d: "जीवन की श्वास, जीवन सिद्धांत; विवेकशील आत्मा; पवित्र आत्मा।",
    u: "नए नियम में 385 बार उपयोग किया गया। पवित्र आत्मा, मानवीय आत्मा या आत्माओं को दर्शाता है।",
    e: "πνέω (प्नेओ) से = फूंक मारना, सांस लेना"
  },
  "G4160": {
    m: "करना, बनाना, पूरा करना",
    d: "करना, बनाना, उत्पादन करना, कार्य करना, सृजन करना। सभी प्रकार की गतिविधि को कवर करने वाली सामान्य क्रिया क्रिया।",
    u: "नए नियम में 568 बार उपयोग किया गया। मूलभूत क्रिया क्रिया, अक्सर परमेश्वर के कार्यों में।",
    e: "प्राथमिक क्रिया; करना, पूरा करना"
  },
  "G4166": {
    m: "चरवाहा, पास्टर",
    d: "जो भेड़ों की रखवाली करता है; आध्यात्मिक रक्षक, कलीसिया का पास्टर।",
    u: "नए नियम में 18 बार उपयोग किया गया। यीशु अच्छा चरवाहा।",
    e: "ποίμνη (पोइम्ने) = झुंड से"
  },
  "G4183": {
    m: "बहुत, कई, महान",
    d: "बहुत, कई, मात्रा या संख्या में महान। भीड़, बड़ी मात्रा।",
    u: "नए नियम में 416 बार उपयोग किया गया। बहुत लगातार मात्रात्मक विशेषण।",
    e: "अनिश्चित जड़; बहुत, कई"
  },
  "G4198": {
    m: "जाना, चलना, यात्रा करना",
    d: "जाना, चलना, यात्रा करना, हिलना। एक स्थान से दूसरे स्थान तक गति, अक्सर उद्देश्य के साथ।",
    u: "नए नियम में 154 बार उपयोग किया गया। सुसमाचार कथाओं में मौलिक गति क्रिया।",
    e: "प्राथमिक क्रिया; जाना, चलना"
  },
  "G4238": {
    m: "करना, अभ्यास करना, पूरा करना",
    d: "करना, अभ्यास करना, पूरा करना, कार्य करना। क्रियाएं करना, अक्सर पुनरावृत्ति या आदत के विचार के साथ।",
    u: "नए नियम में 39 बार उपयोग किया गया। अक्सर अच्छे या बुरे के अभ्यास से जुड़ा।",
    e: "πράω (प्राओ) का प्रबलित रूप; करना, अभ्यास करना"
  },
  "G4263": {
    m: "भेड़",
    d: "भेड़; रूपक में, मसीह के शिष्य।",
    u: "नए नियम में 39 बार उपयोग किया गया। विश्वासी चरवाहे की भेड़ों के समान।",
    e: "संभवतः προβαίνω (प्रोबैनो) = आगे बढ़ना से संबंधित"
  },
  "G4413": {
    m: "पहला, मुख्य",
    d: "समय, स्थान, क्रम या महत्व में पहला।",
    u: "नए नियम में 155 बार उपयोग किया गया। पहली आज्ञा, पहला स्थान।",
    e: "πρό (प्रो) = पहले का उत्तम रूप"
  },
  "G4561": {
    m: "देह, शरीर",
    d: "देह, मांस; मानव शरीर; पतित मानव प्रकृति।",
    u: "नए नियम में 147 बार उपयोग किया गया। देह और आत्मा के बीच अंतर।",
    e: "प्राथमिक मूल"
  },
  "G4592": {
    m: "चिह्न, चमत्कार, अद्भुत कार्य",
    d: "चिह्न, चमत्कार, अद्भुत कार्य; अलौकिक प्रकटीकरण जो दिव्य शक्ति को प्रकट करता है।",
    u: "नए नियम में 77 बार उपयोग किया गया। 'क्योंकि कोई मनुष्य इन चिह्नों को नहीं दिखा सकता जो तू दिखाता है' (यूहन्ना 3:2)।",
    e: "σημεῖον (सेमेइओन) = चिह्न, निशान से"
  },
  "G4648": {
    m: "ध्यान से देखना, निशाना लगाना",
    d: "आँखें टिकाना, ध्यान से विचार करना; ध्यान में रखना, लक्ष्य पर निशाना लगाना।",
    u: "नए नियम में 6 बार उपयोग किया गया। मसीह पर दृष्टि टिकाने का आह्वान।",
    e: "σκοπός (स्कोपोस) = लक्ष्य, उद्देश्य से संबंधित"
  },
  "G4680": {
    m: "बुद्धिमान, ज्ञानी",
    d: "बुद्धिमान, समझदार, कुशल; शिक्षित, विद्वान।",
    u: "नए नियम में 22 बार उपयोग किया गया। सच्ची बुद्धि परमेश्वर से आती है।",
    e: "प्राथमिक मूल"
  },
  "G4982": {
    m: "बचाना, उद्धार करना",
    d: "खतरे या विनाश से बचाना; पाप से उद्धार करना।",
    u: "नए नियम में 106 बार उपयोग किया गया। यीशु पापियों को बचाता है।",
    e: "σῶς (सोस) से = सुरक्षित और स्वस्थ"
  },
  "G5040": {
    m: "छोटा बच्चा",
    d: "छोटा बच्चा, शिशु; शिष्य के लिए स्नेहपूर्ण शब्द।",
    u: "नए नियम में 8 बार उपयोग किया गया। यूहन्ना अपने पाठकों को 'छोटे बच्चे' कहता है।",
    e: "τέκνον (टेक्नोन) = बच्चा का लघु रूप"
  },
  "G5087": {
    m: "रखना, स्थापित करना",
    d: "डालना, रखना; स्थापित करना, नियुक्त करना; जमा करना, रखना।",
    u: "नए नियम में 100 बार उपयोग किया गया। भेड़ों के लिए अपना जीवन देना।",
    e: "प्राथमिक मूल"
  },
  "G5109": {
    m: "दीवार",
    d: "विभाजन की दीवार, दीवार।",
    u: "नए नियम में 1 बार उपयोग किया गया (प्रेरितों 23:3)।",
    e: "प्राथमिक मूल"
  },
  "G5207": {
    m: "पुत्र",
    d: "पुरुष वंशज; शिष्य; समूह का सदस्य। परमेश्वर का पुत्र = यीशु मसीह।",
    u: "नए नियम में 377 बार उपयोग किया गया। अक्सर यीशु को परमेश्वर के पुत्र के रूप में दर्शाने के लिए।",
    e: "अनिश्चित मूल, संभवतः ὕω (हुओ) = बारिश करना, जन्म देना से संबंधित"
  },
  "G5281": {
    m: "धैर्य, सहनशक्ति, दृढ़ता",
    d: "जो परिस्थितियों या दबाव के आगे नहीं झुकता उसका गुण; धैर्यपूर्ण सहनशक्ति, दृढ़ता।",
    u: "नए नियम में 32 बार उपयोग किया गया। आवश्यक मसीही गुण।",
    e: "ὑπό (हुपो) = नीचे और μένω (मेनो) = रहना से"
  },
  "G5312": {
    m: "ऊपर उठाना, महिमा देना",
    d: "ऊंचा उठाना, ऊपर उठाना; महिमा देना, सम्मान करना।",
    u: "नए नियम में 20 बार उपयोग किया गया। मनुष्य का पुत्र ऊपर उठाया गया।",
    e: "ὕψος (हुप्सोस) से = ऊंचाई"
  },
  "G5376": {
    m: "फिलिप्पुस",
    d: "फिलिप्पुस, व्यक्तिवाचक नाम। बारह प्रेरितों में से एक। यूनानी नाम जिसका अर्थ है 'घोड़ों का प्रेमी'।",
    u: "नए नियम में 36 बार उपयोग किया गया। प्रेरित और डीकन का नाम।",
    e: "यूनानी φίλος (फिलोस) = मित्र और ἵππος (हिप्पोस) = घोड़े से"
  },
  "G5432": {
    m: "रक्षा करना, सुरक्षित रखना",
    d: "सैन्य गार्ड से रक्षा करना; सुरक्षित रखना, संरक्षित करना।",
    u: "नए नियम में 4 बार उपयोग किया गया। परमेश्वर की शांति हमारे हृदयों की रक्षा करती है।",
    e: "φρουρός (फ्रूरोस) = पहरेदार, प्रहरी से"
  },
  "G5443": {
    m: "कबीला, वंश",
    d: "कबीला, गोत्र; एक सामान्य पूर्वज से उतरने वाली जनता।",
    u: "नए नियम में 31 बार उपयोग किया गया। इस्राएल के बारह गोत्र।",
    e: "φύω (फ्यूओ) से = उत्पन्न करना, बढ़ाना"
  },
  "G5457": {
    m: "प्रकाश",
    d: "भौतिक या आध्यात्मिक प्रकाश; प्रकट दिव्य सत्य।",
    u: "नए नियम में 73 बार उपयोग किया गया। यीशु संसार का प्रकाश।",
    e: "φάω (फाओ) से = चमकना"
  },
  "G5463": {
    m: "आनंदित होना, खुश होना",
    d: "आनंदित होना, प्रसन्न होना; अभिवादन 'आनंदित हो' या 'नमस्कार'।",
    u: "नए नियम में 74 बार उपयोग किया गया। मसीह में आनंदित होने की लगातार आज्ञा।",
    e: "χάρις (खारिस) = अनुग्रह से संबंधित"
  },
  "G5495": {
    m: "हाथ",
    d: "हाथ; शक्ति, अधिकार; क्रिया, कार्य।",
    u: "नए नियम में 177 बार उपयोग किया गया। परमेश्वर का हाथ, यीशु के हाथ।",
    e: "प्राथमिक मूल"
  },
  "G5544": {
    m: "भलाई, सद्भावना",
    d: "कार्य में भलाई, व्यावहारिक सद्भावना; जो दूसरों के लिए उपयोगी और लाभदायक है उसका गुण।",
    u: "नए नियम में 10 बार उपयोग किया गया। गलातियों 5:22 के अनुसार आत्मा का फल।",
    e: "χρηστός (ख्रेस्तोस) से = अच्छा, उपयोगी, दयालु"
  },
  "G5547": {
    m: "मसीह, मसीहा, अभिषिक्त",
    d: "अभिषिक्त, मसीहा; प्रतिज्ञा किए गए उद्धारकर्ता के रूप में यीशु की उपाधि।",
    u: "नए नियम में 529 बार उपयोग किया गया। यीशु मसीह है।",
    e: "χρίω (ख्रियो) से = अभिषेक करना"
  },
  "G5590": {
    m: "आत्मा, जीवन",
    d: "जीवन की श्वास, जीवित आत्मा; जीवन स्वयं; अमर आत्मा।",
    u: "नए नियम में 105 बार उपयोग किया गया। आध्यात्मिक और शाश्वत जीवन।",
    e: "ψύχω (प्सुखो) से = सांस लेना, ताजा करना"
  },
  "H120": {
    m: "मनुष्य, मानवता, आदम",
    d: "मनुष्य, मानव; मानवता; आदम पहला मनुष्य।",
    u: "पुराने नियम में 562 बार उपयोग किया गया। परमेश्वर ने मनुष्य को बनाया।",
    e: "אָדֹם (आदोम) = लाल, या אֲדָמָה (अदामा) = भूमि से"
  },
  "H160": {
    m: "प्रेम, स्नेह",
    d: "प्रेम, स्नेह; प्रेम का कार्य।",
    u: "पुराने नियम में 40 बार उपयोग किया गया। अपने लोगों के लिए परमेश्वर का प्रेम।",
    e: "אָהַב (आहाव) से = प्रेम करना"
  },
  "H216": {
    m: "प्रकाश",
    d: "प्राकृतिक या आध्यात्मिक प्रकाश; खुशी, समृद्धि।",
    u: "पुराने नियम में 120 बार उपयोग किया गया। 'उजियाला हो!'",
    e: "אוֹר (ओर) से = प्रकाशमान होना"
  },
  "H430": {
    m: "परमेश्वर, देवता",
    d: "सर्वोच्च परमेश्वर (एलोहिम); कभी-कभी न्यायाधीशों या झूठे देवताओं के लिए उपयोग किया जाता है।",
    u: "पुराने नियम में 2606 बार उपयोग किया गया। परमेश्वर के लिए बहुवचन गरिमा का नाम।",
    e: "אֱלוֹהַּ (एलोह) = देवता का बहुवचन"
  },
  "H559": {
    m: "कहना, बोलना",
    d: "कहना, बोलना, घोषणा करना; आज्ञा देना, सोचना।",
    u: "पुराने नियम में 5316 बार उपयोग किया गया। सबसे लगातार भाषण क्रिया।",
    e: "प्राथमिक मूल"
  },
  "H776": {
    m: "पृथ्वी, देश",
    d: "पृथ्वी, मिट्टी; देश, क्षेत्र; सांसारिक संसार।",
    u: "पुराने नियम में 2504 बार उपयोग किया गया। वह पृथ्वी जिसे परमेश्वर ने बनाया।",
    e: "प्राथमिक मूल"
  },
  "H982": {
    m: "भरोसा करना, विश्वास रखना",
    d: "पर भरोसा करना, विश्वास रखना; सुरक्षित होना।",
    u: "पुराने नियम में 120 बार उपयोग किया गया। यहोवा पर भरोसा।",
    e: "प्राथमिक मूल"
  },
  "H1004": {
    m: "घर, निवास",
    d: "घर, आवास; परिवार, घराना; मंदिर।",
    u: "पुराने नियम में 2055 बार उपयोग किया गया। यहोवा का घर।",
    e: "בָּנָה (बाना) से = बनाना"
  },
  "H1254": {
    m: "सृजन करना",
    d: "शून्य से सृजन करना; रूप देना, बनाना; परमेश्वर की विशेष गतिविधि।",
    u: "पुराने नियम में 54 बार उपयोग किया गया। परमेश्वर ने आकाश और पृथ्वी की सृष्टि की।",
    e: "प्राथमिक मूल"
  },
  "H1516": {
    m: "घाटी, खाई",
    d: "घाटी, कण्ठ, खाई; मैदान।",
    u: "पुराने नियम में 60 बार उपयोग किया गया। मृत्यु की छाया की घाटी।",
    e: "प्राथमिक मूल"
  },
  "H1878": {
    m: "मोटा करना, समृद्ध बनाना",
    d: "मोटा करना, समृद्ध बनाना; समृद्ध होना।",
    u: "पुराने नियम में 11 बार उपयोग किया गया। तूने तेल से मेरा सिर अभिषेक किया।",
    e: "דֶּשֶׁן (देशेन) से = मोटापा, राख"
  },
  "H1980": {
    m: "चलना, जाना",
    d: "चलना, जाना, आना; जीना, आचरण करना।",
    u: "पुराने नियम में 1554 बार उपयोग किया गया। बहुत लगातार गति क्रिया।",
    e: "प्राथमिक मूल"
  },
  "H2617": {
    m: "दया, करुणा, वफादारी",
    d: "दया, करुणा; वाचा के प्रति वफादारी; वफादार प्रेम।",
    u: "पुराने नियम में 248 बार उपयोग किया गया। यहोवा की दया।",
    e: "חָסַד (हासाद) से = दयालु होना, कृपालु होना"
  },
  "H2637": {
    m: "कमी होना, जरूरत होना",
    d: "की कमी होना, जरूरत होना; घटना, कमी होना।",
    u: "पुराने नियम में 23 बार उपयोग किया गया। मुझे किसी बात की कमी नहीं (भजन 23:1)।",
    e: "प्राथमिक मूल"
  },
  "H2896": {
    m: "अच्छा, भला",
    d: "अच्छा, सुखद, उत्कृष्ट; दयालु, न्यायी।",
    u: "पुराने नियम में 559 बार उपयोग किया गया। परमेश्वर ने देखा कि यह अच्छा है।",
    e: "प्राथमिक मूल"
  },
  "H3068": {
    m: "यहोवा, प्रभु",
    d: "परमेश्वर का विशेष नाम, पवित्र चतुराक्षर यहवे।",
    u: "पुराने नियम में 6828 बार उपयोग किया गया। सबसे पवित्र नाम।",
    e: "הָיָה (हाया) से = होना, अस्तित्व में होना"
  },
  "H3117": {
    m: "दिन",
    d: "दिन (रात के विपरीत); 24 घंटे की अवधि; युग, समय।",
    u: "पुराने नियम में 2301 बार उपयोग किया गया। वह दिन जो यहोवा ने बनाया।",
    e: "יוֹם (योम) से = गर्म होना"
  },
  "H3372": {
    m: "डरना, भय मानना, आदर करना",
    d: "डरना, भय मानना; आदर करना, परमेश्वर का सम्मान करना।",
    u: "पुराने नियम में 335 बार उपयोग किया गया। मैं किसी बुराई से नहीं डरूंगा।",
    e: "प्राथमिक मूल"
  },
  "H3563": {
    m: "प्याला",
    d: "प्याला, कटोरा; भाग, नियति।",
    u: "पुराने नियम में 31 बार उपयोग किया गया। मेरा प्याला उमड़ रहा है।",
    e: "प्राथमिक मूल"
  },
  "H3820": {
    m: "हृदय, मन",
    d: "हृदय, भावनाओं का स्थान; मन, बुद्धि, इच्छा।",
    u: "पुराने नियम में 598 बार उपयोग किया गया। मनुष्य का हृदय।",
    e: "प्राथमिक मूल"
  },
  "H3915": {
    m: "रात",
    d: "रात (दिन के विपरीत); अंधकार का समय।",
    u: "पुराने नियम में 234 बार उपयोग किया गया। परमेश्वर ने दिन और रात को अलग किया।",
    e: "प्राथमिक मूल"
  },
  "H3966": {
    m: "बहुत, अत्यंत",
    d: "बहुत, अत्यंत, बहुत अधिक; जोर से, तेजी से।",
    u: "पुराने नियम में 300 बार उपयोग किया गया। यह बहुत अच्छा था।",
    e: "מָאַד (मेओद) से = अधिक होना"
  },
  "H4325": {
    m: "जल, पानी",
    d: "पानी, जल; बारिश; बाढ़, समुद्र।",
    u: "पुराने नियम में 585 बार उपयोग किया गया। सृष्टि का जल।",
    e: "מַיִם (मायिम) = पानी का द्विवचन"
  },
  "H4999": {
    m: "चरागाह, निवास",
    d: "चरागाह का स्थान, घास का मैदान; निवास, घर।",
    u: "पुराने नियम में 13 बार उपयोग किया गया। हरी चरागाहों में।",
    e: "נָאָה (नाआ) से = सुंदर होना, उपयुक्त होना"
  },
  "H5148": {
    m: "ले जाना, मार्गदर्शन करना",
    d: "ले जाना, मार्गदर्शन करना, निर्देशित करना; सुरक्षा से ले जाना।",
    u: "पुराने नियम में 40 बार उपयोग किया गया। वह मुझे ले जाता है (भजन 23:3)।",
    e: "प्राथमिक मूल"
  },
  "H5216": {
    m: "चरागाह, खेती की भूमि",
    d: "घास का मैदान, चरागाह; खेती की भूमि, खेत।",
    u: "पुराने नियम में 2 बार उपयोग किया गया। हरी चरागाहें।",
    e: "נִיר (नीर) से = जोतना"
  },
  "H5315": {
    m: "आत्मा, जीवन, व्यक्ति",
    d: "आत्मा, जीवन, जीवित प्राणी; व्यक्ति, स्वयं; इच्छा, भूख।",
    u: "पुराने नियम में 753 बार उपयोग किया गया। मेरी आत्मा, मेरा जीवन।",
    e: "נָפַשׁ (नाफाश) से = सांस लेना"
  },
  "H5769": {
    m: "अनंतता, सदा",
    d: "अनिश्चित समय, अनंतता; सदा, हमेशा।",
    u: "पुराने नियम में 439 बार उपयोग किया गया। परमेश्वर का शाश्वत प्रेम।",
    e: "עָלַם (आलाम) से = छिपाना, छिपा हुआ होना"
  },
  "H6186": {
    m: "व्यवस्थित करना, तैयार करना",
    d: "क्रम में व्यवस्थित करना, तैयार करना; मेज तैयार करना।",
    u: "पुराने नियम में 75 बार उपयोग किया गया। तू मेरे लिए मेज बिछाता है (भजन 23:5)।",
    e: "प्राथमिक मूल"
  },
  "H6213": {
    m: "करना, निर्माण करना",
    d: "करना, बनाना, निर्माण करना; कार्य करना, काम करना।",
    u: "पुराने नियम में 2632 बार उपयोग किया गया। बहुत लगातार क्रिया।",
    e: "प्राथमिक मूल"
  },
  "H6664": {
    m: "धार्मिकता, न्याय",
    d: "धार्मिकता, न्याय, निष्पक्षता; विश्वासयोग्यता।",
    u: "पुराने नियम में 119 बार उपयोग किया गया। धार्मिकता के मार्ग।",
    e: "צָדַק (त्साडाक) से = धार्मिक होना"
  },
  "H6754": {
    m: "छवि, समानता",
    d: "छवि, समानता; रूप, रूप-रचना।",
    u: "पुराने नियम में 17 बार उपयोग किया गया। परमेश्वर की छवि में बना मनुष्य।",
    e: "צָלַל (त्सालाल) से = छाया डालना, समान होना"
  },
  "H6757": {
    m: "मृत्यु की छाया, घोर अंधकार",
    d: "घोर अंधकार, घातक अंधेरा; मृत्यु की छाया।",
    u: "पुराने नियम में 18 बार उपयोग किया गया। अत्यधिक खतरे का प्रतीक।",
    e: "צֵל (त्सेल) = छाया + מָוֶת (मावेत) = मृत्यु से"
  },
  "H6887": {
    m: "संकट में होना, विरोधी",
    d: "संकुचित होना, संकट में होना; विरोधी, शत्रु।",
    u: "पुराने नियम में 58 बार उपयोग किया गया। मेरे शत्रुओं की उपस्थिति में।",
    e: "प्राथमिक मूल"
  },
  "H7121": {
    m: "पुकारना, चिल्लाना, घोषणा करना",
    d: "पुकारना, चिल्लाना; नाम देना; घोषणा करना, बुलाना।",
    u: "पुराने नियम में 736 बार उपयोग किया गया। यहोवा का नाम पुकारना।",
    e: "प्राथमिक मूल"
  },
  "H7200": {
    m: "देखना",
    d: "आँखों से देखना; अनुभव करना, समझना; प्रदान करना।",
    u: "पुराने नियम में 1311 बार उपयोग किया गया। परमेश्वर ने देखा कि यह अच्छा है।",
    e: "प्राथमिक मूल"
  },
  "H7225": {
    m: "आरंभ, पहले फल",
    d: "आरंभ, शुरुआत; सर्वोत्तम, पहले फल।",
    u: "पुराने नियम में 51 बार उपयोग किया गया। 'आदि में परमेश्वर ने...'",
    e: "רֹאשׁ (रोश) से = सिर, आरंभ"
  },
  "H7257": {
    m: "लेटना, आराम करना",
    d: "लेटना, आराम करना; रहना; सेना करना।",
    u: "पुराने नियम में 30 बार उपयोग किया गया। वह मुझे आराम देता है (भजन 23:2)।",
    e: "प्राथमिक मूल"
  },
  "H7291": {
    m: "पीछा करना, खदेड़ना",
    d: "पीछा करना, खदेड़ना; सताना; निकट से अनुसरण करना।",
    u: "पुराने नियम में 144 बार उपयोग किया गया। भलाई मेरा पीछा करेगी।",
    e: "प्राथमिक मूल"
  },
  "H7307": {
    m: "आत्मा, श्वास, वायु",
    d: "श्वास, हवा; परमेश्वर या मनुष्य की आत्मा; मानसिक स्वभाव।",
    u: "पुराने नियम में 378 बार उपयोग किया गया। परमेश्वर की आत्मा।",
    e: "רוּחַ (रूख) से = फूंकना"
  },
  "H7462": {
    m: "चराना, भोजन देना",
    d: "झुंड चराना; चरवाहा होना; भोजन देना, देखभाल करना।",
    u: "पुराने नियम में 173 बार उपयोग किया गया। यहोवा मेरा चरवाहा है।",
    e: "प्राथमिक मूल"
  },
  "H7549": {
    m: "आकाश, आकाशमंडल",
    d: "विस्तार, आकाशीय गुंबद, आकाशमंडल; आकाश।",
    u: "पुराने नियम में 17 बार उपयोग किया गया। पानी के बीच आकाश।",
    e: "רָקַע (राका) से = फैलाना, पीटना"
  },
  "H7626": {
    m: "लाठी, गोत्र",
    d: "लाठी, छड़ी; गोत्र, पारिवारिक शाखा।",
    u: "पुराने नियम में 190 बार उपयोग किया गया। तेरी लाठी और तेरा डंडा।",
    e: "שָׁבַט (शाबाट) से = शाखा"
  },
  "H7725": {
    m: "लौटना, वापस करना, बहाल करना",
    d: "लौटना, वापस करना; बहाल करना, नवीनीकृत करना; पश्चाताप करना।",
    u: "पुराने नियम में 1058 बार उपयोग किया गया। मेरे प्राण को बहाल करना।",
    e: "प्राथमिक मूल"
  },
  "H7979": {
    m: "मेज",
    d: "खाने की मेज; भेंट की रोटी की मेज।",
    u: "पुराने नियम में 71 बार उपयोग किया गया। तैयार की गई मेज।",
    e: "שָׁלַח (शालाख) से = भेजना, फैलाना"
  },
  "H8064": {
    m: "आकाश, स्वर्ग",
    d: "आकाश, आकाशमंडल; परमेश्वर का निवास; दिखाई देने वाला आकाश।",
    u: "पुराने नियम में 420 बार उपयोग किया गया। आकाश और पृथ्वी।",
    e: "שָׁמַיִם (शामायिम) = ऊंचाइयों का द्विवचन"
  },
  "H8414": {
    m: "निराकार, खाली, अराजकता",
    d: "रेगिस्तान, उजाड़; अराजकता, शून्य, निराकार।",
    u: "पुराने नियम में 20 बार उपयोग किया गया। पृथ्वी निराकार और सुनसान थी।",
    e: "תָּהָה (ताहा) से = भटकना"
  }
};

export default strongTranslationsHI;
